module.exports = __webpack_public_path__ + "img/1791994443415.1cfce61c.png";